import React, { useEffect, useState, Fragment, useRef } from 'react';

import { useHistory } from 'react-router-dom';
import { css } from '@emotion/core';
import {
  Button,
  Typography,
  Checkbox,
  ListItemText,
  Dialog,
  DialogContent,
  List,
  ListSubheader,
  Divider,
  ListItem,
  AppBar,
  Toolbar,
  Slide,
  IconButton,
  TextField,
} from '@material-ui/core';

import { useRootStore } from '../../../stores/BridgeProvider';
import ConfirmDialog from '../../dealMapper/common/ConfirmDialog';
import { safeEval, safeFalsy } from '../../util/UtilFunctions';
import Spinner from '../../util/Spinner';

const itemStyle = css`
  :hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

// background-color: rgba(0, 0, 0, 0.04);

const DeleteOrg = ({ orgName }) => {
  const { orgStore, authStore, dataStore } = useRootStore();
  const [text, setText] = useState('');
  const history = useHistory();

  const { isIntegrated } = orgStore;

  const deleteOrg = async () => {
    try {
      await authStore.request.delete(
        `${process.env.REACT_APP_API}/api/delete-organization`,
        {
          data: { isIntegrated },
        },
      );

      history.push('/select-organization');
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <ConfirmDialog
      content={() => (
        <div>
          <div>
            <h3>Delete Organization?</h3>
            <p>
              WARNING: You are about to permanantly delete organization{' '}
              {orgName}.
            </p>
            <p>
              If you wish to proceed, please type the organization name below:
            </p>
            <TextField
              name="Name"
              label={`Organization: ${orgName}`}
              value={text}
              margin="normal"
              onChange={e => setText(e.target.value)}
              variant="outlined"
              fullWidth
            />
          </div>
        </div>
      )}
      actions={({ handleClose }) => (
        <div style={{ width: '100%' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-evenly',
              flex: 1,
              marginBottom: '1rem',
            }}
          >
            <Button
              color="primary"
              variant="contained"
              disabled={orgName !== text}
              onClick={() => {
                deleteOrg();
                handleClose();
              }}
            >
              Confirm
            </Button>
            <Button
              color="secondary"
              variant="contained"
              onClick={() => {
                handleClose();
                setText('');
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      )}
    >
      {({ handleOpen }) => {
        return (
          <ListItem css={itemStyle}>
            <div
              style={{
                cursor: 'pointer',
              }}
            >
              <ListItemText
                onClick={() => handleOpen()}
                primaryTypographyProps={{
                  color: 'secondary',
                }}
                primary="Delete Organization"
                secondary="Permanantly delete organization and all associated data"
              />
            </div>
          </ListItem>
        );
      }}
    </ConfirmDialog>
  );
};

export default DeleteOrg;
